import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const LayoutContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh',
  overflow: 'hidden',
  position: 'relative',
  backgroundColor: theme.palette.mode === 'dark' 
    ? theme.palette.background.default  // Dark mode: #121212
    : theme.palette.grey[50],          // Light mode: #F8F9FA
}));

export const MainContent = styled(Box)(({ theme, sidebarCollapsed }) => ({
  flexGrow: 1,
  marginLeft: sidebarCollapsed ? '45px' : '225px',
  padding: '12px',
  transition: 'all 0.3s ease',
  backgroundColor: theme.palette.mode === 'dark'
    ? theme.palette.background.default  // Dark mode: #121212
    : theme.palette.grey[50],          // Light mode: #F8F9FA
  minHeight: 'calc(100vh - 48px)',
  width: '100%',
  position: 'relative',
  overflowX: 'hidden',
  marginTop: '0',
})); 